/** @format */
import { Component, Input } from '@angular/core';

@Component({
	selector: 'product-reviews-play-button',
	templateUrl: './review-play-button.component.html',
	styleUrl: './review-play-button.component.scss',
	standalone: false
})
export class ReviewPlayButtonComponent {
	@Input() isLarge = false;

	iconSize = { small: '24px', large: '40px' };
}
